import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";
import { canonicalUrl, hrefLangs, organizationJsonLd, pageTitle } from "../../lib/seo";
import { isLocale } from "../../lib/routes";
import type { Locale } from "../../types/content";

type SeoProps = {
  title: string;
  description: string;
};

export function Seo({ title, description }: SeoProps) {
  const { locale } = useParams();
  const location = useLocation();
  const activeLocale: Locale = isLocale(locale) ? locale : "en";
  const path = location.pathname.replace(/^\/(en|ro|he)\/?/, "");

  return (
    <Helmet>
      <html lang={activeLocale} dir={activeLocale === "he" ? "rtl" : "ltr"} />
      <title>{pageTitle(title)}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl(activeLocale, path)} />
      {hrefLangs(path).map((item) => (
        <link key={item.lang} rel="alternate" hrefLang={item.lang} href={item.href} />
      ))}
      <meta property="og:title" content={pageTitle(title)} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl(activeLocale, path)} />
      <meta name="twitter:card" content="summary_large_image" />
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd())}</script>
    </Helmet>
  );
}
